import { ReactNode, useEffect } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import Header from './header';
import Container from '../../shared/container';
import Footer from './footer';
import ScrollToTop from '../../shared/buttons/scroll-to-top';
import Loader from '../../shared/loader';
import { getLoginRedirectURL } from '../../../utils/url';
import { useUser } from '../../../hooks/react-query/use-user';
import { useStudent } from '../../../hooks/react-query/use-student';
import CreateStudentForm from '../../shared/create-student-form';

export type MainLayoutProps = {
  title?: string;
  loginRequired?: boolean;
  studentRequired?: boolean;
  children?: ReactNode;
};

function MainLayout({
  title,
  loginRequired = true,
  studentRequired = true,
  children
}: MainLayoutProps) {
  const location = useLocation();
  const { status: userStatus } = useUser();
  const { status: studentStatus } = useStudent(studentRequired && userStatus === 'success');

  useEffect(() => {
    if (title) document.title = title;
  }, [title]);

  function renderContent() {
    if (studentRequired && studentStatus === 'error')
      return (
        <div className='mx-auto w-full w-full sm:w-4/5 md:w-3/4 lg:w-2/3'>
          <CreateStudentForm />
        </div>
      );

    if (
      (studentRequired && ['indle', 'loading'].includes(studentStatus)) ||
      (loginRequired && userStatus === 'loading')
    ) {
      return (
        <div>
          <Loader />
        </div>
      );
    }

    return children;
  }

  if (loginRequired && userStatus === 'error')
    return <Navigate replace to={getLoginRedirectURL(location.pathname, location.search)} />;

  return (
    <>
      <div className='flex h-screen flex-col'>
        <Header isAuthenticated={userStatus === 'success'} />
        <main data-testid='main' className='flex-1 py-2'>
          <Container>{renderContent()}</Container>
        </main>
        <Footer />
      </div>
      <ScrollToTop />
    </>
  );
}

export default MainLayout;
